const ellipsisStyles = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
export default ellipsisStyles;
//# sourceMappingURL=ellipsisStyles.js.map